import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        menuItem:
            'flex h-9.5 w-full cursor-pointer items-center gap-2 rounded-[0.625rem] border border-transparent ' +
            'bg-transparent px-2 font-inherit text-[0.8rem] font-medium text-slate-300 transition-colors ' +
            'duration-150 ease-out hover:bg-(--white-alpha-06) hover:text-white',
        menuIconWrap:
            'flex h-6.5 w-6.5 shrink-0 items-center justify-center rounded-[0.438rem] ' +
            'shadow-(--sidebar-menu-icon-inset-shadow)'
    }
} satisfies ComponentTheme;
